module.exports = __webpack_public_path__ + "media/images/lb/843-99033c7c958014d4b536123958c3716f.svg";